module.exports = __webpack_public_path__ + "static/media/stofferingen-50.e47e8d08.jpg";